<template>
  <div class="level is-mobile targets">
    <div class="level-item">
      <radial-progress-bar
        :diameter="40"
        :strokeWidth="2"
        :innerStrokeWidth="1"
        :completed-steps="cappedRecordings"
        :total-steps="target.targetDailyRecordings"
        innerStrokeColor="#cccccc"
        startColor="#167df0"
        stopColor="#034794"
        :animateSpeed="2000"
        :title="recordingsTitle"
      >
        <span class="has-text-weight-bold is-size-7">
          {{ target.currentDailyRecordings }}
        </span>
      </radial-progress-bar>
    </div>
    <div class="level-item">
      <radial-progress-bar
        :diameter="40"
        :strokeWidth="2"
        :innerStrokeWidth="1"
        :completed-steps="cappedSeconds"
        :total-steps="target.targetDailySeconds"
        innerStrokeColor="#cccccc"
        startColor="#167df0"
        stopColor="#034794"
        :animateSpeed="2000"
        :title="secondsTitle"
      >
        <span class="has-text-weight-bold is-size-7">
          {{ target.currentDailySeconds }}s
        </span>
      </radial-progress-bar>
    </div>
    <div class="level-item">
      <radial-progress-bar
        :diameter="40"
        :strokeWidth="2"
        :innerStrokeWidth="1"
        :completed-steps="cappedSpellings"
        :total-steps="target.targetDailySpellings"
        innerStrokeColor="#cccccc"
        startColor="#167df0"
        stopColor="#034794"
        :animateSpeed="2000"
        :title="spellingsTitle"
      >
        <span class="has-text-weight-bold is-size-7">
          {{ target.currentDailySpellings }}
        </span>
      </radial-progress-bar>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";

export default {
  props: ["target"],
  components: { RadialProgressBar },
  computed: {
    cappedRecordings() {
      return this.cap(
        this.target.currentDailyRecordings,
        this.target.targetDailyRecordings
      );
    },
    cappedSeconds() {
      return this.cap(
        this.target.currentDailySeconds,
        this.target.targetDailySeconds
      );
    },
    cappedSpellings() {
      return this.cap(
        this.target.currentDailySpellings,
        this.target.targetDailySpellings
      );
    },
    recordingsTitle() {
      return `${this.target.currentDailyRecordings}/${this.target.targetDailyRecordings} recordings`;
    },
    secondsTitle() {
      return `${this.target.currentDailySeconds}/${this.target.targetDailySeconds} seconds`;
    },
    spellingsTitle() {
      return `${this.target.currentDailySpellings}/${this.target.targetDailySpellings} dictation words`;
    }
  },
  methods: {
    cap(x, max) {
      return x < max ? x : max;
    }
  }
};
</script>

<style lang="scss" scoped>
.targets {
  width: 150px;
}
</style>
